import { NgxZendeskWebwidgetConfig } from '../chat/zendesk-webwidget/zendesk-webwidget.model';

import { environment } from 'env/environment';

export class ZendeskConfig extends NgxZendeskWebwidgetConfig {
  // Prevents NgxZendeskWebwidgetService from auto-initializing Zendesk at app startup.
  // Zendesk is initialized on-demand in ChatService.view() only when a Teacher clicks the chat button.
  public lazyLoad = true;
  public accountUrl = environment.zendescAccountUrl;
  public callback(zE: any) {
    zE('webWidget', 'hide');
    zE('webWidget:on', 'close', () => {
      zE('webWidget', 'hide');
    });
  }
}
